import axiosInstance from '@/lib/axios/axiosInstance'
import { apiPath } from '@/constants/api-paths'
import type { ResponseContentEntity } from '@/models/response-types'
import type {
  Task,
  TaskListParams,
  TaskListResponse,
  CreateTaskRequest,
  UpdateTaskRequest,
} from './task-types'

const BASE = apiPath.TASK

export const taskApi = {
  /*** GET /api/master/tasks — `data` is `{ tasks: <page>, assignedOpenCount }` */
  getAll: async (params?: TaskListParams): Promise<TaskListResponse> => {
    const response = await axiosInstance.get(BASE, { params })
    return (response as unknown as ResponseContentEntity<TaskListResponse>).data
  },

  /*** GET /api/master/tasks/{taskId} */
  getById: async (taskId: string): Promise<Task> => {
    const response = (await axiosInstance.get(
      `${BASE}/${taskId}`,
    )) as unknown as ResponseContentEntity<Task>
    return response.data
  },

  /*** POST /api/master/tasks */
  create: async (payload: CreateTaskRequest) => {
    // Return full envelope so hooks can surface the backend `message`.
    return (await axiosInstance.post(BASE, payload)) as unknown as ResponseContentEntity<Task>
  },

  /*** PUT /api/master/tasks/{taskId} */
  update: async (taskId: string, payload: UpdateTaskRequest) => {
    return (await axiosInstance.put(
      `${BASE}/${taskId}`,
      payload,
    )) as unknown as ResponseContentEntity<Task>
  },

  /*** PUT /api/master/tasks/{taskId}/complete */
  complete: async (taskId: string) => {
    return (await axiosInstance.put(
      `${BASE}/${taskId}/complete`,
    )) as unknown as ResponseContentEntity<Task>
  },

  /*** PATCH /api/master/tasks/{taskId}/archive */
  archive: async (taskId: string) => {
    return (await axiosInstance.patch(
      `${BASE}/${taskId}/archive`,
    )) as unknown as ResponseContentEntity<Task>
  },

  /*** PATCH /api/master/tasks/{taskId}/restore */
  restore: async (taskId: string) => {
    return (await axiosInstance.patch(
      `${BASE}/${taskId}/restore`,
    )) as unknown as ResponseContentEntity<Task>
  },
}
